module.exports = __webpack_public_path__ + "static/media/sample_home.bcc3d588.jpg";